import React, { useEffect, useRef, useState } from "react";
import { Button, Col, ConfigProvider, DatePicker, Flex, Row } from "antd";
import Spinner from "../../Atomics/Spinner";
import { SelectAtomic } from "../../Atomics/SelectAtomic";
import { ElectricEnergy } from "../../Molecules/Registry/ElectricEnergy";
import { ProductionEnergy } from "../../Molecules/Registry/ProductionEnergy";
import { AverageElectricConsumption } from "../../Molecules/Registry/AverageElectricConsumption";
import { LoadDiagram } from "../../Molecules/Registry/LoadDiagram";
import { ExportRawData } from "../../Molecules/Registry/ExportRawData";
import { CostTable } from "../../Molecules/Registry/CostTable";
import { GasConsumption } from "../../Molecules/Registry/GasConsumption";
import { CertificationTable } from "../../Molecules/Registry/CertificationTable";
import { EventsTable } from "../../Molecules/Registry/EventsTable";
import { RelatedAssetsTable } from "../../Molecules/Registry/RelatedAssetsTable";
import { Widget } from "../../Atomics/Widget";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import domtoimage from "dom-to-image";
import { useAuthContext } from "../../../../contexts/AuthContext";
import i18next from "i18next";
import enUS from 'antd/lib/locale/en_US';
import ptBR from 'antd/lib/locale/pt_BR';
import useFetch from "../../../../server/useFetch";
import query from "../../../../server/constants.api";
import { Text } from "../../Atomics/Text";

export const RegistryHistorical = ({ dataRegisterDetail }) => {
    const { t } = useTranslation();
    const { checkToken } = useAuthContext();
    const [showExportButton, setShowExportButton] = useState(false);
    const [showApplyButton, setShowApplyButton] = useState(true);
    const [selectPeriodFilter] = useState([ //Actualizar com fetch de configuraçoes
        { value: 'monthly', label: t('monthly') },
        { value: 'quarter', label: t('quarter') },
        { value: 'annual', label: t('annual') }
    ]);
    const [selectPeriodType, setSelectPeriodType] = useState('annual');
    const [periodicity, setPeriodicity] = useState(null);
    const [pickerType, setPickerType] = useState(null);
    const [pickerPlaceHolder, setPickerPlaceHolder] = useState(dayjs().year());
    const [startPeriod, setStartPeriod] = useState(null);
    const [endPeriod, setEndPeriod] = useState(null);
    const [dataToFilter, setDataToFilter] = useState({
        "period": 'annual',
        "periodicity": "Monthly",
        "startDate": dayjs().tz('UTC').startOf('year').toDate(),
        "endDate": dayjs().tz('UTC').endOf('year').toDate()
    });
    const [placeholder, setPlaceholder] = useState();
    const [resetValue, setResetValue] = useState(null);
    const [dataActiveEnergy, setDataActiveEnergy] = useState(null);
    const [dataInductiveEnergy, setDataInductiveEnergy] = useState(null);
    const [dataCapacitiveEnergy, setDataCapacitiveEnergy] = useState(null);
    const [dataProductionEnergy, setDataProductionEnergy] = useState(null);
    const [dataAverageElectricConsumption, setDataAverageElectricConsumption] = useState(null);
    const [dataLoadDiagram, setDataLoadDiagram] = useState(null);
    const [dataCostSimulation, setDataCostSimulation] = useState(null);
    const [dataGasConsumption, setDataGasConsumption] = useState(null);
    const [dataEvents, setDataEvents] = useState(null);
    const [dataRelatedAssets, setDataRelatedAssets] = useState(null);
    dayjs.locale(i18next.resolvedLanguage === 'en' ? 'en' : 'pt-br')

    const [voltage, setVoltage] = useState(null);

    useEffect(() => {
        setVoltage(dataRegisterDetail?.data?.voltage)
    }, [dataRegisterDetail]);

    const disabledDate = (current) => {
        const today = new Date();
        const minDate = new Date('2022-01-01');
        const maxDate = today;
        return current && (current < minDate || current > maxDate);
    };
    function handleSelectPeriodFilter(value) {
        if (value !== selectPeriodType) { setPlaceholder(t('selectPeriod')) };
        setSelectPeriodType(value)
    };
    useEffect(() => {
        switch (selectPeriodType) {
            case 'annual':
                setPeriodicity('Monthly');
                setPickerType('year');
                setStartPeriod(null);
                setEndPeriod(null);
                break;
            case 'quarter':
                setPeriodicity('Daily');
                setPickerType('quarter');
                setStartPeriod(null);
                setEndPeriod(null);
                break;
            default:
                setPeriodicity('Daily');
                setPickerType('month');
                setStartPeriod(null);
                setEndPeriod(null);
        }
        setResetValue(null);
    }, [selectPeriodType]);

    const handlePickerChange = (date, dateString) => {
        let newPlaceholder = '';
        let startDate = null;
        let endDate = null;

        switch (pickerType) {
            case 'year':
                newPlaceholder = date?.format('YYYY');
                setPickerPlaceHolder(date?.format('YYYY'));
                startDate = date?.startOf('year');
                endDate = date?.endOf('year');
                break;

            case 'quarter':
                const quarter = Math.floor((date?.month() + 3) / 3);
                newPlaceholder = `Q${quarter}, ${date?.format('YYYY')}`;
                setPickerPlaceHolder(`Q${quarter}, ${date?.format('YYYY')}`);
                startDate = date?.startOf('day');
                endDate = startDate?.clone().add(3, 'months').subtract(1, 'day').endOf('day');

                break;

            case 'month':
                newPlaceholder = date?.format('MMM, YYYY');
                setPickerPlaceHolder(date?.format('MMM, YYYY'));
                startDate = date?.startOf('month');
                endDate = date?.endOf('month');

                break;

            default:

                break;
        }


        // Set time to midnight (00:00:00) for startDate and endDate
        startDate?.set({ hour: 0, minute: 0, second: 0 });
        endDate?.set({ hour: 0, minute: 0, second: 0 });

        setPlaceholder(newPlaceholder);
        setResetValue(date);
        setStartPeriod(startDate?.$d);
        setEndPeriod(endDate?.$d)
    };

    const applyFilters = () => {
        const data = {
            period: selectPeriodType,
            periodicity: periodicity,
            picker: pickerPlaceHolder,
            startDate: startPeriod,
            endDate: endPeriod,
        };

        checkToken();//Validate token
        setDataToFilter(data);
        setShowApplyButton(false);
    }

    //Potency type
    const [selectPotencyTypeRaw, setSelectPotencyTypeRaw] = useState(null);

    useEffect(() => {
        let data = [];
        console.log('dataActiveEnergy ', dataActiveEnergy)
        console.log('dataInductiveEnergy ', dataInductiveEnergy)
        console.log('dataCapacitiveEnergy ', dataCapacitiveEnergy)
        console.log('dataProductionEnergy ', dataProductionEnergy)

        if (dataActiveEnergy?.data) {
            data.push({ value: 'Potência Ativa', label: t('activePotency') })
        }
        if (dataInductiveEnergy?.data) {
            data.push({ value: 'Potência Reativa Indutiva', label: t('reactiveIndutivePotency') })
        }
        if (dataCapacitiveEnergy?.data) {
            data.push({ value: 'Potência Reativa Capacitiva', label: t('reactiveCapacitivePotency') })
        }
        if (dataProductionEnergy?.production?.series?.length) {
            data.push({ value: 'Potência de Produção', label: t('productionPotency') })
        }
        setSelectPotencyTypeRaw(data)
    }, [dataActiveEnergy, dataInductiveEnergy, dataCapacitiveEnergy, dataProductionEnergy]);

    //#endregion

    //#region ---------------Report------------------//
    const [reportLoading, setReportLoading] = useState(false);
    const [printImages, setPrintImages] = useState(false);
    const [isToGenerateReport, setIsToGenerateReport] = useState(false);

    const [registryDetailImages, setRegistryDetailImages] = useState(null);
    const [totalCost, setTotalCost] = useState(null);

    const electricityActivePowerRef = useRef(null);
    const electricityInductivePowerRef = useRef(null);
    const electricityCapacitivePowerRef = useRef(null);
    const electricityProductionPowerRef = useRef(null);
    const electricityConsumePowerRef = useRef(null);
    const costRef1 = useRef(null);
    const costRef2 = useRef(null);
    const costRef3 = useRef(null);
    const loadDiagramRef = useRef(null);
    const gasRef = useRef(null);
    const certificationTableRef = useRef(null);
    const eventsTableRef = useRef(null);

    const captureChart = async (chartRef) => {
        const chartContainer = chartRef.current;

        // Capture o conteúdo do gráfico como uma imagem usando dom-to-image
        const chartDataUrl = await domtoimage.toPng(chartContainer);

        return chartDataUrl;
    };

    async function fetchImages() {
        setTimeout(async () => {
            const data = {
                activePowerImage: dataActiveEnergy?.activeEnergy?.series?.length ? await captureChart(electricityActivePowerRef) : null,
                inductivePowerImage: dataInductiveEnergy?.indutiveEnergy?.series?.length ? await captureChart(electricityInductivePowerRef) : null,
                capacitivePowerImage: dataCapacitiveEnergy?.capacitiveEnergy?.series?.length ? await captureChart(electricityCapacitivePowerRef) : null,
                productionPowerImage: dataProductionEnergy?.production?.series?.length ? await captureChart(electricityProductionPowerRef) : null,
                // consumePowerImage: dataAverageElectricConsumption?.weekdayAverage?.series?.length ? await captureChart(electricityConsumePowerRef) : null,
                loadDiagramImage: dataLoadDiagram?.potency?.series?.length ? await captureChart(loadDiagramRef) : null,
                gasImage: dataGasConsumption?.gas?.series?.length ? await captureChart(gasRef) : null,
                certificationTableImage: await captureChart(certificationTableRef),
                eventsTableImage: await captureChart(eventsTableRef),
                costsImage1: dataCostSimulation ? await captureChart(costRef1) : null,
                costsImage2: dataCostSimulation ? await captureChart(costRef2) : null,
                costsImage3: dataCostSimulation ? await captureChart(costRef3) : null
            }
            setRegistryDetailImages(data);
            setIsToGenerateReport(true);
            setPrintImages(false);
        }, '10000')
    }

    useEffect(() => {
        if (printImages) {
            checkToken();//Validate token
            setReportLoading(true);
            fetchImages();
        }
    }, [printImages])

    const {
        data: reportData,
        isLoading: reportIsLoading
    } = useFetch(query.path.generateReport, 'getDetailRegistryReport',
        {
            filters: { frequency: pickerType, granularity: periodicity, period: pickerPlaceHolder },
            itemProperties: dataRegisterDetail,
            dataActiveEnergy: dataActiveEnergy,
            dataInductiveEnergy: dataInductiveEnergy,
            dataCapacitiveEnergy: dataCapacitiveEnergy,
            dataProductionEnergy: dataProductionEnergy?.production?.series?.length ? dataProductionEnergy : null,
            dataConsumptionEnergy: dataAverageElectricConsumption?.weekdayAverage?.series?.length ? dataAverageElectricConsumption : null,
            dataLoadConsumption: dataLoadDiagram?.potency?.series?.length ? dataLoadDiagram : null,
            dataGasConsumptionEnergy: dataGasConsumption?.gas?.series?.length ? dataGasConsumption : null,
            dataEvents: dataEvents ? dataEvents : null,
            images: registryDetailImages,
            totalCost: totalCost
        }, isToGenerateReport, 'POST');

    useEffect(() => {
        if (reportData) {
            try {
                // Decode the Base64 string
                const binaryString = atob(reportData.data);

                // Create a Uint8Array from the decoded binary data
                const uint8Array = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }

                // Create a Blob from the Uint8Array
                const blob = new Blob([uint8Array], { type: 'application/octet-stream' });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', dataRegisterDetail?.title + '.docx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            catch (error) {
                // logger.error('Error download registry report');
                console.error('download registry report error: ', error);
            }
            finally {
                setReportLoading(false)
                setIsToGenerateReport(false);
            }
        }
    }, [reportData])
    //#endregion

    const [loadingEvents, setLoadingEvents] = useState(true);
    const [loadingGasConsumption, setLoadingGasConsumption] = useState(true);
    const [loadingCostSimulation, setLoadingCostSimulation] = useState(true);
    const [loadingLoadDiagram, setLoadingLoadDiagram] = useState(true);
    const [loadingProductionEnergy, setLoadingProductionEnergy] = useState(true);
    const [loadingCertificationTable, setCertificationTable] = useState(true);

    useEffect(() => {
        if (!loadingProductionEnergy && !loadingLoadDiagram && !loadingGasConsumption
            && !loadingCostSimulation && !loadingCertificationTable && !loadingEvents) {
            setShowApplyButton(true);
        }
    }, [dataActiveEnergy, dataInductiveEnergy, dataCapacitiveEnergy, dataProductionEnergy, dataLoadDiagram, dataGasConsumption, dataCostSimulation, loadingCertificationTable, loadingEvents]);

    useEffect(() => {
        if (!loadingProductionEnergy && !loadingLoadDiagram && !loadingGasConsumption
            && !loadingCostSimulation && !loadingEvents) {
            setTimeout(() => {
                setShowExportButton(true);
            }, 5000);
        }
    }, [dataActiveEnergy, dataInductiveEnergy, dataCapacitiveEnergy, dataProductionEnergy, dataAverageElectricConsumption, dataLoadDiagram, dataGasConsumption, dataCostSimulation, loadingEvents]);

    return (
        <Flex className='ant-anchors-content' vertical="true">
            <Row gutter={[16, 16]} align='middle'>
                <Col span={3} offset={15}>
                    <SelectAtomic
                        optionsData={selectPeriodFilter}
                        handleOptionsChange={handleSelectPeriodFilter}
                        fullWidth={true}
                        defaultValue={'annual'}
                    /></Col>
                <Col span={4}>
                    {/* We are using ptBR cause in the librrary of Ant Design theres a bug on the portuguese language pt_PT */}
                    <ConfigProvider locale={i18next.resolvedLanguage === 'en' ? enUS : ptBR}>
                        <DatePicker className='full-width'
                            size='large'
                            onChange={handlePickerChange}
                            format={pickerType === 'quarter' ? "Qº, YYYY" : pickerType === 'year' ? 'YYYY' : "MMM, YYYY"}
                            picker={pickerType}
                            disabledDate={disabledDate}
                            placeholder={placeholder ?? dayjs().year()}
                            value={resetValue}
                        />
                    </ConfigProvider>
                </Col>
                <Col span={2}>
                    {showApplyButton ?
                        <Button disabled={periodicity !== null && startPeriod !== null && endPeriod !== null ? false : true} shape="round" className="ant-btn ant-btn-blue -medium" onClick={applyFilters}>{t('apply')}</Button>
                        : <Spinner stroke="green" size='30px' />}
                </Col>
            </Row>

            <Flex id='Eletric Energy' className='ant-anchors-content-item' gap={32} vertical="true">

                <ElectricEnergy dataToFilter={dataToFilter}
                    //Para o component de export excel
                    hasActiveEnergy={(value) => setDataActiveEnergy(value)}
                    hasInductiveEnergy={(value) => setDataInductiveEnergy(value)}
                    hasCapacitiveEnergy={(value) => setDataCapacitiveEnergy(value)}
                />

                <ProductionEnergy dataToFilter={dataToFilter} electricityProductionPowerRef={electricityProductionPowerRef}
                    hasProductionEnergy={(value) => setDataProductionEnergy(value)}
                    isProductionEnergyLoading={(value) => setLoadingProductionEnergy(value)} />

                <AverageElectricConsumption dataToFilter={dataToFilter} />
                {/* electricityConsumePowerRef, hasAverageElectricData, isAverageElectricDataLoading */}

            </Flex>

            <LoadDiagram dataToFilter={dataToFilter} loadDiagramRef={loadDiagramRef}
                hasLoadDiagramData={(value) => setDataLoadDiagram(value)}
                isLoadDiagramLoading={(value) => setLoadingLoadDiagram(value)} />

            <ExportRawData selectPotencyTypeRaw={selectPotencyTypeRaw}
                filterPeriod={{ startPeriod: startPeriod, endPeriod: endPeriod }}
                pickerPlaceHolder={pickerPlaceHolder}
                fileTitle={dataRegisterDetail?.title}
                hideField={selectPeriodType === 'annual' ? true : false} />

            {dataRegisterDetail?.data ?
                <CostTable dataToFilter={dataToFilter} costRef1={costRef1} costRef2={costRef2} costRef3={costRef3} voltage={voltage}
                    hasCostSimulation={(value) => setDataCostSimulation(value)}
                    isCostSimulationLoading={(value) => setLoadingCostSimulation(value)}
                    simulationTotalCost={(value) => setTotalCost(value)} />
                : null
            }
            <GasConsumption dataToFilter={dataToFilter} gasRef={gasRef}
                hasGasConsumption={(value) => setDataGasConsumption(value)}
                isGasConsumptionLoading={(value) => setLoadingGasConsumption(value)} />

            <CertificationTable dataToFilter={dataToFilter} certificationTableRef={certificationTableRef}
                isCertificationTableLoading={(value) => setCertificationTable(value)} />

            <EventsTable dataToFilter={dataToFilter} eventsTableRef={eventsTableRef}
                hasEvents={(value) => setDataEvents(value)}
                isEventsLoading={(value) => setLoadingEvents(value)} />

            <RelatedAssetsTable
                hasRelatedAssets={(value) => setDataRelatedAssets(value)} />

            <Row className={printImages ? '' : 'hidden'}>
                <Col span={24}>
                    <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('imagesForReport')}</Text>
                </Col>
                <Col span={18} offset={6}>

                    <div ref={electricityActivePowerRef}>
                        <Widget data={{
                            height: '482px',
                            background: 'white',
                            title: t('activeEnergy'),
                            icon: 'Bolt',
                            charts: [{
                                key: 0,
                                chartType: 'columnsChartApex',
                                chartId: 'barChartWithMultiXAxisOne',
                                data: dataActiveEnergy?.activeEnergy,
                            }]
                        }} />
                    </div>
                    <div ref={electricityInductivePowerRef}>
                        <Widget data={{
                            height: '482px',
                            background: 'white',
                            title: t('inductiveReactiveEnergy'),
                            icon: 'Bolt',
                            charts: [{
                                key: 1,
                                chartType: 'columnsChartApex',
                                chartId: 'barChartWithMultiXAxisOne',
                                data: dataInductiveEnergy?.indutiveEnergy,
                            }]
                        }} />
                    </div>
                    <div ref={electricityCapacitivePowerRef}>
                        <Widget data={{
                            height: '482px',
                            background: 'white',
                            title: t('capacitiveReactiveEnergy'),
                            icon: 'Bolt',
                            charts: [{
                                key: 2,
                                chartType: 'columnsChartApex',
                                chartId: 'barChartWithMultiXAxisOne',
                                data: dataCapacitiveEnergy?.capacitiveEnergy,
                            }]
                        }} />
                    </div>
                </Col>
            </Row>
        </Flex>
    );
};